export const SEARCH_UMO = 'SEARCH_UMO';
export const EXTERNAL_URL = 'EXTERNAL_URL';
export const ADMIN_SCREEN = 'ADMIN_SCREEN';
export const EXTERNAL_ADMIN_SCREEN = 'EXTERNAL_ADMIN_SCREEN';
export const HIGHLIGHTS_VIEW = 'HIGHLIGHTS_VIEW';


export const ADMIN_PUBLISH = 'ADMIN_PUBLISH';

export const MODAL_VIEW_TYPE_SHARE = 'MODAL_VIEW_TYPE_SHARE';
export const MODAL_VIEW_TYPE_DOWNLOAD = 'MODAL_VIEW_TYPE_DOWNLOAD';
export const MODAL_VIEW_TYPE_DYNAMIC_DOWNLOAD = 'MODAL_VIEW_TYPE_DYNAMIC_DOWNLOAD';



// WEBPACK FOOTER //
// ./src/js/constants/mainContentTypes.js